export default "__VITE_ASSET__ErzZD7_M__"